export default {
	"tag": "li",
	"data-id": "${place_id}",
	"data-value":"${description}",
	"children": [{
		"tag": "div",
		"children": [{
			"tag": "span",
			"html": "${before}"
		}, {
			"tag": "b",
			"class": "match",
			"html": "${match}"
		}, {
			"tag": "span",
			"class": "name",
			"html": "${name}"
		}]
	}, {
		"tag": "em",
		"class": "address",
		"html": "${address}"
	}]
};



// WEBPACK FOOTER //
// ./public/scripts/webpack/templateGM.js